// extracted by mini-css-extract-plugin
export default {"password_email":"passwordReset_password_email__t7-2X"};